import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'p8-settings-header',
  templateUrl: './settings-header.component.html',
  styleUrls: ['./settings-header.component.scss']
})
export class SettingsHeaderComponent implements OnInit {
  @Input() titlePath: string[] = [];

  constructor() { }

  ngOnInit() {
  }

}
